import { createApi } from "./api";

class PatrolsService {
  constructor() {
    this.api = createApi("/patrol");
  }

  getPatrols() {
    return this.api.get(`/getPatrols`);
  }

  update(id, score) {
    return this.api.patch(`/update/${id}/${score}`);
  }
}

const patrolService = new PatrolsService();

export default patrolService;
